module.exports = __webpack_public_path__ + "assets/google.501aa703.svg";